import React, { useEffect, useState } from 'react';
import { FormControl, InputAdornment } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import FieldNames from '../../../defaults/FieldNames.json';
import { useSelector } from 'react-redux';
import BasicTextField from './BasicTextField';
import Events from '../../../defaults/Events';

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red"
    },
    "&&:after": {
      borderBottom: "2px solid red"
    }
  },
});

const useNotSavedStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid gold"
    },
    "&&:after": {
      borderBottom: "2px solid gold"
    }
  },
});

const theme = createTheme({
  overrides: {
    
  },
});

export default function DetailsInteragencyText({id, item, field, otherInteragencySelected, setOtherInteragencySelected, geoID, geoType, userInfo, isDisabled = false}) {
  const [value, setValue] = useState(item);

  return (
    <FormControl variant="standard" fullWidth>
      <ThemeProvider theme={theme}>
      <BasicTextField
        id={id}
        value={value}
        setValue={setValue}
        field={field}
        otherInteragencySelected={otherInteragencySelected}
        setOtherInteragencySelected={setOtherInteragencySelected}
        label=""
        variant={"standard"}
        placeholder={""}
        useFullWidth={true}
        helperText = {isDisabled ? "" : "Please enter a value."}
        geoID={geoID}
        geoType={geoType}
        userInfo={userInfo}
        useMultiline={true}
        isDisabled={isDisabled}
        triggerEvent={Events.TriggerInteragencyFieldChange}
        index={id}
      />
      </ThemeProvider>
    </FormControl>)
}